export default "__VITE_ASSET__C2qw03oz__"